import Phonogram from '../../assets/images/phonogram.jpg';
import MathClub from '../../assets/images/mathClub.png';

const pattonNewsData = [
    {
        img_url: 'https://i.imgur.com/8rljZg3.jpg',
        title: "Gift endows, names Jeb E. Brooks School of Public Policy",
        description: "The major gift from the Brooks family, whose roots span three generations, provides the early boost to help the university's newest school achieve world-class experience.",
        type: "latest"
    },
    {
        img_url: MathClub,
        title: "Mann award winner unveils evolution, rules of gene expression",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer a dui vulputate, fringilla felis nec, consequat ante. Curabitur egestas tristique eros id faucibus.",
        type: "latest"
    },
    {
        img_url: Phonogram,
        title: "Monolayer superconductor exhibits unusual behavior",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer a dui vulputate, fringilla felis nec, consequat ante. Curabitur egestas tristique eros id faucibus.",
        type: "trending"
    },
    {
        img_url:"https://image.freepik.com/free-vector/music-event-poster-template-with-abstract-shapes_1361-1316.jpg",
        title: "Novel liquid crystal metalens offers electric zoom",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer a dui vulputate, fringilla felis nec, consequat ante. Curabitur egestas tristique eros id faucibus.",
        type: "trending"
    },
    {
        img_url:"https://image.freepik.com/free-vector/music-event-poster-template-with-abstract-shapes_1361-1316.jpg",
        title: "Novel liquid crystal metalens offers electric zoom",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer a dui vulputate, fringilla felis nec, consequat ante. Curabitur egestas tristique eros id faucibus.",
        type: "latest"
    },
];

export default pattonNewsData;